import * as Yup from "yup";

export interface AddStudentsToGroupFormFields {
  studentEmails?: string[];
}

export const buildAddStudentsToGroupFormSchema = (): Yup.SchemaOf<AddStudentsToGroupFormFields> =>
  Yup.object({
    studentEmails: Yup.array().of(Yup.string().email()).optional(),
  }).required();
